'use client';

import type { EventBusListener } from '@hc-frontend/core-events';
import type { SubmitFormEvent } from '@hc-frontend/core-ui';
import { useEventBus } from '@hc-frontend/core-ui';
import { trackSubmitForm } from '@hc-frontend/third-party-snowplow';
import { useCallback, useEffect } from 'react';

export function FormEventsSubscription() {
  const eventBus = useEventBus();

  const handleFormSubmit = useCallback<
    EventBusListener<SubmitFormEvent, (EventTarget & HTMLFormElement) | null>
  >((event) => {
    trackSubmitForm(
      {
        id: event.submitForm.id,
        elements: event.submitForm.elements,
      },
      event.contexts,
    );
  }, []);

  useEffect(() => {
    eventBus.subscribe('core.ui.form.submit', handleFormSubmit);

    return () => {
      eventBus.unsubscribe('core.ui.form.submit', handleFormSubmit);
    };
  }, [handleFormSubmit, eventBus]);

  return null;
}
